import i18n from 'utils/i18n'
import CheckBox from 'theme/CheckBox'
import Button from "theme/Button";
import { StyleSheet, View } from 'react-native'
import Description from 'components/atoms/Description'
import _ from 'lodash'
import Form from 'components/molecules/Form'
import { FormFieldsConstants } from 'utils/constants/form-constants';
import ThemedModal from 'components/atoms/ThemedModal'
import React, { useEffect, useState } from 'react'
import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationEmployeeBookingStatus from 'graphql/mutations/MutationEmployeeBookingStatus'
import { constantsActive } from 'utils/constants/constants'
import { bookingStatus } from 'utils/constants/booking-constants'
import HelperString from 'utils/helper-string'
import HelperDate, { dateFormat } from 'utils/helper-date'

const ModalRemove = ({ visible = false, bookings, onHide, reload }) => {
	
	const [ saving, setSaving ] = useState( false )
	const [ selected, setSelected ] = useState( [] )
	const [ formValues, setFormValues ] = useState( {} )
	
	const setVisible = () => {
		if( _.isFunction( onHide ) ) {
			onHide();
		}
	}
	
	const onRemove = () => {
		// Remove the guids together
		const graphqlBuilder = new GraphqlBuilder();
		
		_.forEach( selected, guid => {
			graphqlBuilder.addQuery( `mutation_employee_booking_status_${ guid }`, MutationEmployeeBookingStatus, {
				guid: guid,
				active: constantsActive.NO,
				status: bookingStatus.CANCELLED,
				cancel_reason: _.get( formValues, 'reason', null )
			})
		})
		
		graphqlBuilder.setOnStart( setSaving.bind( this, true ) );
		
		graphqlBuilder.setOnSuccess( (result) => {
			if( _.isFunction( reload ) ) {
				reload({
					withLoading: false
				});
			}
			
			setVisible( false )
			setSaving( false )
		});
		
		graphqlBuilder.setOnError( setSaving.bind( this, false ) );
		
		graphqlBuilder.execute()
	}
	
	const onSelect = ( guid, nextChecked ) => {
		let list = [ ...selected ];
		
		if( !nextChecked ) {
			list = _.filter( list, o => {
				return o !== guid;
			});
		} else {
			list.push( guid );
		}
		
		setSelected( list )
	}
	
	useEffect( () => {
		if( !visible ) {
			setSelected( [] )
			setFormValues( {} )
		}
	}, [ visible ] )
	
	return (
		<ThemedModal
			visible={ visible }
			setVisible={ setVisible.bind( this ) }
			title={ i18n.t('management:pages.bookings.view.remove.reason') }
			footer={(
				<>
					<Button
						appearance="ghost"
						onPress={ setVisible.bind( this ) }>
						
						{ i18n.t('page.coworker.alert.cancel' ) }
					</Button>
					
					<Button
						isLoading={ saving }
						onPress={ onRemove.bind( this ) }>
						
						{ i18n.t('management:pages.bookings.view.remove.button') }
					</Button>
				</>
			)}>
			
			<View
				style={ styles.modalRemoveTimeslotContent }>
				
				<Description>{ i18n.t('management:pages.bookings.view.remove.description') }</Description>
				
				{ _.map( bookings, booking => {
					return (
						<CheckboxBooking
							booking={ booking }
							selected={ selected }
							onChange={ onSelect.bind( this ) }
						/>
					);
				}) }
			</View>
			
			<Form
				values={ formValues }
				fields={[
					{
						name: 'reason',
						label: null,
						type: FormFieldsConstants.TEXT_AREA,
					}
				]}
				onChange={ setFormValues.bind( true ) }
				onlyFields={ true }
			/>
		</ThemedModal>
	)
}

const CheckboxBooking = ({ booking, selected, onChange }) => {
	const checked = _.includes( selected, booking.guid );
	
	const timeslot = _.get( booking, 'timeslot', {} );
	const timeslotStart = HelperDate.date( timeslot.timeslot_start, dateFormat.FULL_TIME ).format( dateFormat.SHORT_TIME );
	const timeslotEnd = HelperDate.date( timeslot.timeslot_end, dateFormat.FULL_TIME ).format( dateFormat.SHORT_TIME );
	
	const name = `${ i18n.t('management:form_block.title_timeslot') }: ${ timeslotStart } - ${ timeslotEnd }`
	
	return (
		<CheckBox
			key={ HelperString.hash( 'checkbox-booking', booking ) }
			style={ styles.modalRemoveTimeslotContentRow }
			checked={ checked }
			onChange={ nextChecked => {
				return onChange(booking.guid, nextChecked);
			} }>
			
			{ name }
		</CheckBox>
	)
}

const styles = StyleSheet.create({
	modalRemoveTimeslotContent: {
		marginBottom: 8
	},
	modalRemoveTimeslotContentRow: {
		paddingVertical: 4
	},
})

export default ModalRemove
